import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
Vue.config.productionTip = false;

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);

// eslint-disable-next-line vue/multi-word-component-names
Vue.component("apexchart", VueApexCharts);

new Vue({
  apexcharts: {
    theme: {
      mode: "dark",
    },
    tooltip: {
      theme: "dark",
    },
  },
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
